import { useQuery } from "@tanstack/react-query";
import useAxiosPrivate from "@/hooks/useAxiosPrivate";

export interface UseCaseData {
  settings: {
    organization?: any;
    processing?: {
      metadata?: {
        extractionFields?: any[];
      };
      products?: {
        extractionFields?: any[];
      };
      reprocess_onChange_customer?: { value: boolean };
    };
    checks_order_products?: {
      quantity_moq_verification?: {
        value?: boolean;
      };
    };
    checks?: {
      order?: {
        products?: {
          quantity_moq_verification?: {
            value?: boolean;
          };
        };
      };
    };
    checks_order_metadata?: any;
    entities?: any;
    interface?: any;
    display?:any;
  };
}

export const useUseCasesData = () => {
  const axiosPrivate = useAxiosPrivate();
  
  return useQuery<UseCaseData, Error>({
    queryKey: ["useCasesData"],
    queryFn: async () => {
      const response = await axiosPrivate.get(`/useCases`);
      return response.data.data[0]; 
    },
    staleTime: 600000, // 10 minutes
    gcTime: 600000, // 10 minutes
  });
};